import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faPaperPlane,
} from "@fortawesome/free-solid-svg-icons";
import {
  faInstagram,
  faWhatsapp,
} from "@fortawesome/free-brands-svg-icons";

import { Link } from "react-router-dom";
import "../../styles/app/Footer.css";
import TermsModal from "../common/TermsModal";
import PrivacyModal from "../common/PrivacyModal";
import RefundModal from "../common/RefundModal";
import FAQModal from "../common/FAQModal";
import PickupModal from "../common/PickupModal";
import LockerModal from "../common/LockerModal";
import DocumentsModal from "../common/DocumentsModal";
import elPaketLogoIMG from "../../assets/images/logo-elpaket.png";
import packageInfo from "../../../package.json";

interface FooterProps {
  hideGrid?: boolean;
}

//Footer
const Footer: React.FC<FooterProps> = ({ hideGrid = false }) => {
  const brandName = process.env.REACT_APP_BRAND_NAME;
  const infoEmail = process.env.REACT_APP_INFO_EMAIL;
  const rawEnv = (process.env.REACT_APP_IS_PROD || "").toUpperCase();
  const isProd = rawEnv === "TRUE" || rawEnv === "PROD";
  const isDev = rawEnv === "DEV";
  const envName = isProd ? "PROD" : isDev ? "DEV" : "TEST";
  const rawVersion = packageInfo.version || "";
  const cleanVersion = rawVersion.replace(/^[vV]+\.?/, "");
  const versionDisplay = `v.${cleanVersion} - ${envName}`;
  const [showTerms, setShowTerms] = useState(false);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showRefund, setShowRefund] = useState(false);
  const [showFAQ, setShowFAQ] = useState(false);
  const [showPickup, setShowPickup] = useState(false);
  const [showLocker, setShowLocker] = useState(false);
  const [showDocuments, setShowDocuments] = useState(false);

  return (
    <footer id="contact" className="footer">
      {!hideGrid && (
        <div className="footer-grid">
          <div>
            <Link to="/">
              <img
                src={elPaketLogoIMG}
                alt="elPaket - Envíos a Latinoamérica"
                style={{ height: "44px", objectFit: "contain", cursor: "pointer" }}
              />
            </Link>
            <p>La forma más fácil y rápida de enviar a Latinoamérica</p>
          </div>
          <div>
            <h4>Servicios</h4>
            <ul>
              <li>
                <a href="/servicios#recogida-pickup">Recogida de Pickup</a>
              </li>
              <li>
                <a href="/servicios#recogida-dropoff">Recogida de DropOff</a>
              </li>
              <li>
                <a href="/servicios#envio-documentos">Envío de Documentos</a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Compañía</h4>
            <ul>
              <li>
                <a href="/company#quienes-somos">Quiénes Somos</a>
              </li>
              <li>
                <a href="/company#mision">Misión</a>
              </li>
              <li>
                <a href="/company#vision">Visión</a>
              </li>
              <li>
                <a href="/company#valores">Valores</a>
              </li>
            </ul>
          </div>
          <div>
            <h4>Legal</h4>
            <ul>
              <li>
                <a href="/articulos-prohibidos"> Artículos Prohibidos</a>
              </li>
              <li>
                <button
                  onClick={() => setShowTerms(true)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    padding: 0,
                    font: "inherit",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  Términos y Condiciones
                </button>
              </li>
              <li>
                <button
                  onClick={() => setShowPrivacy(true)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    padding: 0,
                    font: "inherit",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  Política de Privacidad
                </button>
              </li>
              <li>
                <button
                  onClick={() => setShowRefund(true)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    padding: 0,
                    font: "inherit",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  Política de Reembolsos
                </button>
              </li>
              <li>
                <button
                  onClick={() => setShowFAQ(true)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "inherit",
                    padding: 0,
                    font: "inherit",
                    cursor: "pointer",
                    textDecoration: "none",
                  }}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  Preguntas Frecuentes
                </button>
              </li>
            </ul>
          </div>
          <div>
            <h4>Contacto</h4>
            <ul>
              <li>
                <FontAwesomeIcon icon={faPhone} />{" "}
                <a href={`tel:${process.env.REACT_APP_WHATSAPP_NUMBER || "+17868380122"}`}>
                  {process.env.REACT_APP_CONTACT_PHONE}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} />{" "}
                <a href={`mailto:${infoEmail}`}>{infoEmail}</a>
              </li>
            </ul>

            <h4 style={{ marginTop: "var(--space-4)" }}>Síguenos</h4>
            <div className="social" style={{ marginTop: "var(--space-2)" }}>
              <a
                href="https://www.instagram.com/elpake.t"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
            <a href="/contacto" className="footer-contact-link" style={{ display: "inline-block", marginTop: "var(--space-4)" }}>
              <FontAwesomeIcon icon={faPaperPlane} /> Envíanos un mensaje
            </a>
          </div>
        </div>
      )}
      <div className="footer-bottom">
        &copy; {new Date().getFullYear()} elPaket un producto de EnviarLatam
        LLC. Todos los derechos reservados.
        <span className="footer-version-tag"> &bull; {versionDisplay}</span>
      </div>

      {/* Stripe Legal Disclaimer — Required by Stripe Compliance (31 CFR § 515.542(a)) */}
      <div className="footer-stripe-disclaimer">
        <p>
          <strong>Stripe Payment Disclaimer:</strong> Stripe does not process,
          facilitate, or participate — directly or indirectly — in any payment,
          transaction, or financial activity associated with shipments, deliveries,
          or services involving Cuba. All payments processed through Stripe on this
          platform are exclusively related to logistics services to non-restricted
          destinations. Any Cuba-related services offered by EnviarLatam LLC operate
          entirely outside the Stripe payment ecosystem and are handled through
          alternative, independent payment channels.
        </p>
        <p>
          <strong>Aviso Legal de Pagos — Stripe:</strong> Stripe no procesa,
          facilita ni participa — directa o indirectamente — en ningún pago,
          transacción o actividad financiera asociada con envíos, entregas o
          servicios relacionados con Cuba. Todos los pagos procesados a través de
          Stripe en esta plataforma corresponden exclusivamente a servicios de
          logística hacia destinos no restringidos. Cualquier servicio relacionado
          con Cuba ofrecido por EnviarLatam LLC opera enteramente fuera del
          ecosistema de pagos de Stripe y se gestiona a través de canales de pago
          alternativos e independientes.
        </p>
      </div>

      <TermsModal show={showTerms} onHide={() => setShowTerms(false)} />

      <PrivacyModal show={showPrivacy} onHide={() => setShowPrivacy(false)} />

      <RefundModal show={showRefund} onHide={() => setShowRefund(false)} />

      <FAQModal show={showFAQ} onHide={() => setShowFAQ(false)} />

       <PickupModal show={showPickup} onHide={() => setShowPickup(false)} />

      <LockerModal show={showLocker} onHide={() => setShowLocker(false)} />

      <DocumentsModal
        show={showDocuments}
        onHide={() => setShowDocuments(false)}
      />
    </footer>
  );
};

export default Footer;
